exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#TopBanner {\n  box-shadow: unset;\n  color: #404950;\n  min-width: 100%;\n  font-size: .9rem; }\n  #TopBanner.element-box {\n    margin-bottom: 0 !important;\n    padding: 1rem 1rem;\n    box-shadow: unset;\n    background-color: #f2f5fe !important; }\n", ""]);

// exports
